import ErrorFallback from '@dtsl/react-ui-components/dist/components/ErrorFallback/index';

function ErrorFallbackWrapper() {
  return (
    <ErrorFallback
      backURL={window.location.href}
      logoURL={window.location.href}
      isBrevo
      env={import.meta.env.VITE_ENV as string}
      isAppMFE={false}
    />
  );
}

export default ErrorFallbackWrapper;
